<template>
  <div class="w-full flex justify-between items-end">

    <div class="flex  shrink-0 flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="title">Názov</label>
      <InputText placeholder="Obec / mesto" v-model="state.name" size=""/>
    </div>

    <div class="flex  shrink-0 flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="title">Názov</label>
      <InputText placeholder="Variacie" v-model="state.variations" size=""/>
    </div>

    <div class="w-[220px]">
      <b class="text-surface-500 text-sm">Vyberte položku v PLU </b>
      <MySelect v-model="state.pluItemId"
                :options="pluOptions"
                placeholder="Vyberte položku v PLU"
                class="w-full mt-1 "
                :filter="true"
                :key="key"
      />

    </div>

    <div class="flex w-[110px] shrink-0 flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="title">Min. cena obj.</label>
      <InputText placeholder="" v-model="state.minOrderPrice" size=""/>
    </div>

    <div class="flex w-[110px] shrink-0 flex-col mt-2 gap-1">
      <label class="text-surface-500 text-sm" for="title">Min. počet jedal</label>
      <InputText placeholder="" v-model="state.minOrderAmount" size=""/>
    </div>

    <SelectButton v-model="state.restaurantPlace"
                  :options="RESTAURANT_PLACES"
                  aria-labelledby="basic"
                  size="small"
                  option-value="value"
                  optionLabel="name"
    />

    <div class="flex items-center h-full space-x-2">
      <Button v-if="props.index !== 0"
              @click="emit('delete-delivery-place',state.id)"
              label="Zmazať"
              size="small"
              severity="danger"
              icon="pi pi-trash"
              iconPos="right"
      />
      <Button @click="$emit('save-delivery-place',{...state})" size="small" label="Uložiť" colo iconPos="right"/>
    </div>

  </div>
</template>

<script setup>
import {computed, watch} from "vue";
import {RESTAURANT_PLACES} from "@/content/lists.js"
import MySelect from "@/components/inputs/MySelect.vue"
import usePluStore from "@/stores/pluStore.js";

const props = defineProps({
  index: {
    type: Number
  }
})
const state = defineModel()
const emit = defineEmits(['delete-delivery-place', 'save-delivery-place'])

const pluStore = usePluStore()

const pluOptions = computed(() => {
  if (state.value.restaurantPlace === 'BO') {
    return [...pluStore.pluItemsBo]
  }
  return [...pluStore.pluItemsPE]
})

let key = 1
watch(pluOptions, (nv, ov) => {
  key++
}, {deep: true})

// watch(() => state.value.restaurantPlace, (nv, ov) => {
//   state.value.pluItemId = null
// }, {deep: true})

</script>